import * as React from 'react';

import { Modal, Button } from 'react-bootstrap';

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant: 'danger' | 'info';
  confirmBtnLabel?: string;
  cancelBtnLabel?: string;
  title: string;
  description: string;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  description,
  confirmBtnLabel = 'Yes',
  cancelBtnLabel = 'No',
  onSubmit,
  onClose,
}) => {
  return (
    <Modal show={open} onHide={onClose} animation={false}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        {variant === 'danger' && (
          <>
            <Button variant="secondary" onClick={onClose} autoFocus>
              {cancelBtnLabel}
            </Button>
            <Button variant="primary" onClick={onSubmit}>
              {confirmBtnLabel}
            </Button>
          </>
        )}

        {variant === 'info' && (
          <Button variant="primary" onClick={onSubmit} autoFocus>
            OK
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
